import BaseSubscriptionDetailsTheme from 'base/components/standalone/SubscriptionDetails/theme';

export default Object.assign(BaseSubscriptionDetailsTheme, { Accordion: BaseSubscriptionDetailsTheme.Accordion });
